import { memo } from "react";
import { useFloatingDropZoneCalculator } from "../Hooks/useFloatingDropZoneCalculator";
import { useVisibleDropZones } from "../Hooks/useVisibleDropZones";
import { FloatingDropZoneItem } from "./FloatingDropZoneItem";

export const FloatingDropZonesView = memo(() => {
  const visibleDropZones = useVisibleDropZones();
  useFloatingDropZoneCalculator();

  return (
    <div
      className="pointer-events-none absolute inset-0"
      data-testid="builder-ui-floating-drop-zones"
    >
      {visibleDropZones.map(position => (
        <FloatingDropZoneItem
          key={`${position.path}:${position.index}`}
          {...position}
        />
      ))}
    </div>
  );
});

FloatingDropZonesView.displayName = "FloatingDropZonesView";
